import SignaturePad from './SignaturePad'
import SignaturePadContainer from './SignaturePadContainer'

SignaturePad.Container = SignaturePadContainer

export default SignaturePad
